import React from 'react'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import Icon from '@forwardflow/ui/Icons'
import { Avatar } from 'antd'
import { getPlatformType } from '@forwardflow/helpers/utils'

dayjs.extend(duration)

interface MessageItemProps {
   item: any
}

export const AppointmentRescheduledItem: React.FC<MessageItemProps> = ({
   item,
}) => {
   return (
      <div className="flex flex-col items-end justify-end gap-x-2">
         <div className="flex items-center justify-between bg-[#594180] py-4 px-8 w-full gap-y-4 text-[12px]">
            <div className="flex items-center gap-x-4">
               <Icon name="AppointmentScheduledSmall" className="fill-white" />
               <p className="font-medium">Appointment Rescheduled</p>
            </div>
            <p>{dayjs(item?.ts).format('h:mm A, D MMM YYYY')}</p>
         </div>
         <div className="flex gap-3 bg-[#473466] w-full py-5 pl-8 pr-11 items-center cursor-pointer">
            <div className="px-4 py-2 rounded-full flexc gap-x-3 bg-black/20">
               <p className="text-[12px] border-r pr-3">
                  {dayjs(item?.appointment?.time).format('h:mm A, D MMM YYYY')}
               </p>
               <p>
                  {getPlatformType(
                     item?.appointment?.platform?.split('(PLACEHOLDER)')
                  )}
               </p>
            </div>
            <div className="flex items-center gap-x-3">
               {item?.invitees?.map((data: any, index: any) => {
                  return (
                     <div key={index}>
                        <div className="pr-5 rounded-full flexc bg-black/20">
                           <p className="text-[12px] font-medium pr-2">
                              <Avatar
                                 src={data?.avatar}
                                 className="w-10 h-10 bg-[#851E58]"
                              >
                                 {data?.name.slice(0, 1) || 'A'}
                              </Avatar>
                           </p>
                           <p className="text-[12px] font-medium">
                              {data?.name}
                           </p>
                        </div>
                     </div>
                  )
               })}
            </div>
         </div>
      </div>
   )
}
